// extracted by mini-css-extract-plugin
export default {"Reports":"Reports_Reports__-OHGJ","secondLayer":"Reports_secondLayer__lmwzL","header":"Reports_header__afG9g"};